/**
 * url跳转
 */
let print, shop, activity, prefixUrl, shopEditUri, activityEditUri, fenceBindingUri, fenceViewUri
const env = process.env.VUE_APP_NODE_ENV
const publicPath = process.env.VUE_APP_PUBLIC_PATH + '#'

switch (env) {
    case 'development':
        prefixUrl = publicPath
        print = publicPath + '/print'
        shop = publicPath + '/shop/edit'
        activity = publicPath + '/activity/edit'
        shopEditUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/popact/shopEditor.html` // 店铺装修iframe
        activityEditUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/popact/activityEditor.html` // 活动装修iframe
        fenceBindingUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/map/design.html` // 围栏绑定iframe
        fenceViewUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/map/view.html` // 围栏查看iframe
        break
    case 'test':
    case 'prem':
        prefixUrl = publicPath
        print = publicPath + '/print'
        shop = process.env.VUE_APP_DO_MAIN + publicPath + '/shop/edit'
        activity = process.env.VUE_APP_DO_MAIN + publicPath + '/activity/edit'
        shopEditUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/popact/shopEditor.html` // 店铺装修iframe
        activityEditUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/popact/activityEditor.html` // 活动装修iframe
        fenceBindingUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/map/design.html` // 围栏绑定iframe
        fenceViewUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/map/view.html` // 围栏查看iframe
        break
    // case 'prem':
    //     prefixUrl = publicPath
    //     print = publicPath + '/print'
    //     shop = process.env.VUE_APP_DO_MAIN + publicPath + '/shop/edit'
    //     activity = process.env.VUE_APP_DO_MAIN + publicPath + '/activity/edit'
    //     shopEditUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/popact/shopEditor.html` // 店铺装修iframe
    //     activityEditUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/popact/activityEditor.html` // 活动装修iframe
    //     fenceBindingUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/map/design.html` // 围栏绑定iframe
    //     fenceViewUri = `${process.env.VUE_APP_DO_MAIN}/ddPlatform/map/view.html` // 围栏查看iframe
    //     break
    case 'production':
        prefixUrl = publicPath
        print = publicPath + '/print'
        shop = process.env.VUE_APP_DO_MAIN + publicPath + '/shop/edit'
        activity = process.env.VUE_APP_DO_MAIN + publicPath + '/activity/edit'
        shopEditUri = `${process.env.VUE_APP_DO_MAIN}/popact/shopEditor.html` // 店铺装修iframe
        activityEditUri = `${process.env.VUE_APP_DO_MAIN}/popact/activityEditor.html` // 活动装修iframe
        fenceBindingUri = `${process.env.VUE_APP_DO_MAIN}/map/design.html` // 围栏绑定iframe
        fenceViewUri = `${process.env.VUE_APP_DO_MAIN}/map/view.html` // 围栏查看iframe
        break
    default:
        break
}

export const prefix = prefixUrl // 打印跳转的url
export const printUrl = print // 打印跳转的url
export const shopUrl = shop // 店铺装修跳转的url
export const activityUrl = activity // 活动装修跳转的url
export const shopEditUrl = shopEditUri // 店铺装修iframe
export const activityEditUrl = activityEditUri // 活动装修iframe
export const fenceBindingUrl = fenceBindingUri // 围栏绑定iframe
export const fenceViewUrl = fenceViewUri // 围栏查看iframe
